import React, { useEffect, useRef, useCallback, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Navbar, NavDropdown, Nav, NavLink, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import axios from 'axios';
import { a } from 'react-spring';



export default function Index() {
    const [ result, setResult ] = useState([]);
    const [ cpu, setCpu ] = useState([]);
    const resultRef = useRef();

    const ResponsiveNavbar = () => {
        return (
            <Navbar collapseOnSelect expand='sm' bg='dark' variant='dark'>
                <Container>
                    <Navbar.Toggle aria-controls='responsive-navbar-nav' />
                    <Navbar.Collapse id='responsive-navbar-nav'>
                        <Nav>
                            <Nav.Link href='/Admin/Index'>Home</Nav.Link>
                            <Nav.Link href='/Admin/Users'>Users</Nav.Link>
                            <Nav.Link href='/Admin/Roles'>Roles</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        );
    };
    // https://github.com/wearefractal/nodeinfo

    const ServerInfo = () => { 
        axios.get('http://localhost:5000/ServerInfo')
            .then((response) => { 
                console.log(response.data);
            })
            .catch((error) => { 
                console.log(error);
            })
    }

    useEffect(() => { 
       ServerInfo();
    });

    useEffect(() => { 
        ServerInfo();
    }, [cpu])
    

    return (
        <React.Fragment>
            <Container>
                <Row>
                    <h1>Admin</h1>
                   
                    <h2>Server Info</h2>
                    <hr />
                    <Table striped bordered hover variant className="serverInfo">
                        <thead>
                            <tr>
                                <th>CPU Information</th>
                            </tr>
                            
                        </thead>
                        <tbody>
                            <tr>
                                <td>Model:</td>
                                <td>{cpu.model}</td>
                            </tr>
                            <tr>
                                <td>Speed:</td>
                                <td>{cpu.speed}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Row>
            </Container>
        </React.Fragment>
    )
}